/**
 * Icon mapper
 * @param {String} data - icon data
 * @return {Object} - normalized data
 */
export default (data: `${string}--${string}` | null): { category: string; name: string } | null => {
  if (!data || !data.includes('--')) {
    return null
  }
  const iconNames = data.split('--') as [string, string]
  return {
    category: iconNames[0],
    name: iconNames[1]
  }
}
